import { getFloorNameForFloor, getJustUnnasigned, getRoomName } from 'src/utils/projectTreeAdapterForOfferPage';
import { GetProjectTreeProjectChildNode } from 'src/model/api/get-project-tree-project-childnode.model';
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';

export const getTablesNewFormat = (
  tables: any[],
  svgs: any[]|null,
  lightingCalcs: any,
  projectTreeNodes: GetProjectTreeProjectChildNode[],
  projectQuoteUserProperties: ProjectQuoteUserProperties
) => {
  if (!Array.isArray(tables)) {
    return { tableFloors: [], nonRoomTables: [] };
  }

  let tableFloors: any[] = [];
  let tableFloorsObj: any = {};

  let roomTables: any[] = [];
  let nonRoomTables: any[] = [];

  tables.forEach((table) => {
    if (table.entitytype.indexOf("roomtable") === 0) {
      roomTables.push(table);
    } else {
      nonRoomTables.push(table);
    }
  });

  roomTables.forEach((table: any) => {
    if (table.floorId in tableFloorsObj) {
      const tableFloor = tableFloorsObj[table.floorId];
      const room = tableFloor.tableRooms.find((room: any) => room.id === table.id);
      if (room) {
        room.tables.push(table);
      } else {
        tableFloor.tableRooms.push({
          id: table.id,
          name: getRoomName(table.id, projectTreeNodes),
          just_unassigned_floor: getJustUnnasigned(table.floorId, projectTreeNodes),
          tables: [table],
        });
      }
    } else {
      const newFloor = {
        id: table.floorId,
        name: getFloorNameForFloor(table.floorId, projectTreeNodes),
        tableRooms: [
          {
            id: table.id,
            name: getRoomName(table.id, projectTreeNodes),
            just_unassigned_floor: getJustUnnasigned(table.floorId, projectTreeNodes),
            tables: [table],
          },
        ],
      };
      tableFloorsObj[table.floorId] = newFloor;
    }
  });

  for (let key in tableFloorsObj) {
    tableFloors.push(tableFloorsObj[key]);
  }

  tableFloors.forEach((tableFloor) => {
    tableFloor.tableRooms.forEach((tableRoom: any) => {
      tableRoom.tables.sort((a: any, b: any) => {
        return a.entitytype === "roomtable_count" ? -1 : 0;
      });
      tableRoom.hasRows = !!tableRoom.tables.find(
        (table: any) => table.rows.length > 0
      );
    });
    tableFloor.hasRows = !!tableFloor.tableRooms.find(
      (tableRoom: any) => tableRoom.hasRows
    );
  });

  tableFloors.sort((a, b) => {
    return a.id - b.id;
    /* return a.name.localeCompare(b.name); */
  });

  if (
    !!svgs &&
    "plannerSVGs" in svgs &&
    "roomProps" in svgs &&
    "roomSVGs" in svgs
  ) {
    const svgObj: any = svgs;
    tableFloors.forEach((tableFloor) => {
      tableFloor.floorSvgObj = svgObj.plannerSVGs.find(
          (plannerSVG: any) =>
              +plannerSVG.floorId === +tableFloor.id &&
              !plannerSVG.isWifi &&
              !plannerSVG.isCamera &&
              !plannerSVG.isWiring
      );
      tableFloor.floorWiringSvgObjs = svgObj.plannerSVGs
          .filter(
              (plannerSVG: any) =>
                  +plannerSVG.floorId === +tableFloor.id && plannerSVG.isWiring
          )
          .sort((a: any, b: any) => {
            return `${a.wiringType}`.localeCompare(`${b.wiringType}`);
          });
      tableFloor.floorWifiSvgObjs = svgObj.plannerSVGs.filter(
          (plannerSVG: any) =>
              +plannerSVG.floorId === +tableFloor.id && plannerSVG.isWifi
      );
      tableFloor.floorWifiSvgObjs.forEach(
          (wifiSVG: any) => (wifiSVG["legend"] = svgObj["signal-legend"])
      );
      tableFloor.floorCameraSvgObj = svgObj.plannerSVGs.find(
          (plannerSVG: any) =>
              +plannerSVG.floorId === +tableFloor.id && plannerSVG.isCamera
      );
      if (lightingCalcs) {
        tableFloor.lightingCalc = lightingCalcs[tableFloor.id];
      }
      tableFloor.tableRooms.forEach((tableRoom: any) => {
        if (tableRoom.id in svgObj.roomProps) {
          tableRoom.airspace = svgObj.roomProps[tableRoom.id].airspace;
          tableRoom.area = svgObj.roomProps[tableRoom.id].area;
        }
        tableRoom.roomSvgObj = svgObj.roomSVGs.find(
            (roomSVG: any) => +roomSVG.roomId === +tableRoom.id
        );
      });
      tableFloor.hasRoomMaps = !!tableFloor.tableRooms.find(
          (tableRoom: any) => !!tableRoom.roomSvgObj
      );
    });
  }

  const hiddenTables = getHiddenTables(projectQuoteUserProperties);

  nonRoomTables = nonRoomTables.filter(
      (table) => hiddenTables.indexOf(table.entitytype) === -1
  );
  // TODO: resolvethis
  // if (entityType === "racktable") {
  //   // a pinoutba lévő it eszközöket is állítjuk HA a it chekboxot kikapcsoljuk
  //   $(".itDeviceToPinout").hide();
  // }

  return { tableFloors, nonRoomTables };
};


function getHiddenTables( projectQuoteUserProperties: ProjectQuoteUserProperties ): string[] {
  let hiddenTables: string[] = [];
  if (projectQuoteUserProperties.include_conv_dev_in_ec === 0) {
    hiddenTables.push('convfunctiontable');
  }
  if (projectQuoteUserProperties.include_nhc_din_table === 0) {
    hiddenTables.push('nhcdintable');
  }
  if (projectQuoteUserProperties.include_cables === 0) {
    hiddenTables.push('projectcablestable');
  }
  if (projectQuoteUserProperties.include_it_products === 0) {
    hiddenTables.push('racktable');
  }
  if (projectQuoteUserProperties.include_functions_table === 0) {
    hiddenTables.push('functiontable');
  }
  return hiddenTables;

}